import { render, staticRenderFns } from "./Categories.html?vue&type=template&id=01d464c3&scoped=true&"
import script from "./Categories.js?vue&type=script&lang=js&"
export * from "./Categories.js?vue&type=script&lang=js&"
import style0 from "./Categories.scss?vue&type=style&index=0&id=01d464c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d464c3",
  null
  
)

export default component.exports